import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

import { getCategories } from '../../store/reducers/categories'
import { getLoggedUser } from '../../selectors/user'
import { sendMindbox } from '../../helpers/hocs'

import Item from './Item'

const Categories = ({ items = [], current = null, withAll = true, onClick, classPrefix = 'Persons', intl }) => !items.length ? null : (
  <h1 className={[ 'Head', classPrefix + '__header' ].join(' ')}>
    {withAll && <Item isCurrent={!current} name={intl.formatMessage({id: 'categories_index.all_categories'})} isLast={!items.length} onClick={onClick} classPrefix={classPrefix} />}
    {items.map((el, i) => <Item {...el} isCurrent={el._id === current} isLast={i === (items.length - 1)} onClick={onClick} key={`category-${el._id}`} classPrefix={classPrefix} />)}
  </h1>
)

const mapStateToProps = state => ({ items: state.categories, user: getLoggedUser(state) })
const mapDispatchToProps = dispatch => bindActionCreators({ getCategories }, dispatch)
const mergeProps = (state, { getCategories }, {typelot = 'all', type, project, ...props }) => {
  const get = (params = {}) =>{ 
    params = { ...params, typelot, project}
    getCategories(type, params)
  }
  return { ...props, ...state, get}
}
export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount () {
      this.props.get(this.props.type)
    },
    componentWillReceiveProps (np) {
      if (np.type && (np.type !== this.props.type)) this.props.get(np.type)
      //console.log('какие пропсы в категориях*****************', np)
      
      //отправка данных mindbox о просмотре категории
      if (typeof window !== 'undefined' && (np.user && Object.keys(np.user).length > 0)) {
        if (np.current) {
          /*window.mindbox("async", {
            operation: "Website.ViewCategory",
            data: {
              customer: {
                email:  np.user.emails[0]
              },
              viewProductCategory: {
                productCategory: {
                  ids: {
                    website: np.current
                  }
                }
              }
            },
            onSuccess: function() {console.log('данные о просмотре лота записались**************') },
            onError: function(error) {console.log('ошибка записи в mindbox**************', error) }
          });*/

          const mindboxData = {
            "customer": {
              "email": np.user.emails[0]
            },
            "viewProductCategory": {
              "productCategory": {
                "ids": {
                  "website": np.current
                }
              }
            }
          }

          sendMindbox(mindboxData, 'viewCategories')
        }
      }
    }
  })
)(Categories))



// WEBPACK FOOTER //
// ./src/containers/Categories/index.jsx